//settings.ts

import { apiProvider } from "./utilities/provider";

export const settingsApi = {
  update: (d: {
    workflow?: string;
    ShowBatchColors?: boolean;
    tasksTitle?: string;
    customLabels?: string;
  }): Promise<void> =>
    apiProvider.patch("settings", undefined, {
      data: d,
    }),
};
